// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DocumentW9 = ({
  userMeta,
  handleChangeView,
  handleSaveUserMeta,
  updateSpecificProjectDataProperty
}) => {
  const [file, setFile] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [ajaxResponse, setAjaxResponse] = useState({ type: '', message: '' });
  const [filenameLoading, setFilenameLoading] = useState(false);
  const isFIP = window.wlPipConfig.isFIP ?? false;
  const hasUploadedW9 = isFIP
    ? userMeta.has_uploaded_fip_w9
    : userMeta.has_uploaded_w9;

  const handleFileSelect = (event) => {
    if (event.target.files[0].type !== 'application/pdf') {
      setError('Please upload a PDF document.');
      setFile(undefined);
    } else {
      setError('');
      setFile(event.target.files[0]);
    }
  };

  // Run this whenever the value of 'file' changes. (uploads document to server)
  useEffect(() => {
    if (!file) return;

    setLoading(true);
    setFilenameLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_pip_doc_upload');
    formData.append('doc_type', 'w-9');
    formData.append('file', file, file.name);

    if (isFIP) {
      formData.append('fip', isFIP);
    }

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(({ data: { success, data } }) => {
        setAjaxResponse({
          type: success ? 'success' : 'error',
          message: data.message
        });

        setLoading(false);
        setFilenameLoading(false);

        if (isFIP) {
          updateSpecificProjectDataProperty(
            'has_uploaded_fip_w9',
            data.has_uploaded_fip_w9
          );
        } else {
          updateSpecificProjectDataProperty(
            'has_uploaded_w9',
            data.has_uploaded_w9
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, [file]);

  return (
    <div id="upload-w9">
      <div className="grid u--font-size-lg">
        <div className="grid__col-xs-12">
          {error && (
            <div className="notice notice--error">
              <p>
                <span className="notice__title">Warning.</span> {error}
              </p>
            </div>
          )}
          {hasUploadedW9 && (
            <p
              className={`u--margin-bottom-10 u--font-size-md${
                filenameLoading ? ' is-loading' : ''
              }`}
            >
              We have your W-9 on file for year <strong>{hasUploadedW9}</strong>
              .
            </p>
          )}
          <div
            className="form__field form__field--required"
            style={{ maxWidth: '600px' }}
          >
            <small className="form__help">
              <span className="form__help-icon icon icon--md perc-icon-caret-right"></span>
              Must be a PDF File.
            </small>
            <label className="custom-file-upload">
              <input
                type="file"
                className="u--display-none"
                onChange={(event) => handleFileSelect(event)}
              />
              <div
                className={`btn btn--upload btn--link btn--lg btn--block btn--upload ${
                  file !== undefined ? 'btn--upload--ready' : ''
                } ${
                  file !== undefined && file['name'].length > 40
                    ? 'btn--md'
                    : 'btn--lg'
                }`}
              >
                <span className="btn__content">
                  <span className="btn__text">
                    {file !== undefined ? file.name : 'Select File'}
                  </span>
                </span>
              </div>
            </label>
          </div>
          {ajaxResponse.type && ajaxResponse.message && (
            <div
              className={`notice notice--${ajaxResponse.type}`}
              role="alert"
              style={{ maxWidth: '600px' }}
            >
              {ajaxResponse.message}
            </div>
          )}
        </div>
        <div className="grid__col-xs-12">
          <button
            id="pip-add__save-w9"
            className={`btn btn--gold btn--md module-hover-root ${
              loading ? 'btn--loading' : ''
            }`}
            type="button"
            onClick={() => handleSaveUserMeta()}
            disabled={loading || !file}
          >
            <span className="btn__content">
              <span className="btn__text">Save W-9 document</span>
            </span>
          </button>
          <button
            className="btn btn--white btn--outline btn--md module-hover-root u--margin-left-30"
            type="button"
            onClick={() => handleChangeView()}
          >
            <span className="btn__content">
              <span className="btn__text">Back to My Account Overview</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentW9;
